import { TAGS } from "../routes/super_admin/tags/Tags";
import {
  ACC_CONTACT_URL,
  APT_RESOURCE_URL,
  DEFAULT_CONTACT_URL,
  DEFAULT_RESOURCE_URL,
  CARDINAL_RESOURCE_URL,
  IS_ACC_ORIGIN,
  IS_CARDINAL_ORIGIN,
  IS_LANDMARK_ORIGIN,
  LANDMARK_CONTACT_URL,
  CARDINAL_CONTACT_URL,
} from "./general";
import { PORTFOLIO_LIST } from "../routes/super_admin/portfolio/PortfolioList";
import { PROFILE_PHOTO_JOBS } from "../routes/super_admin/profile_photos/ProfilePhotoJobs";

export const URL = {
  LOGIN: "/",
  ADMIN_ACCESS_REQUEST_CONTROL: "/super-admin/admin-requests",
  PUSH_TEST: "/super-admin/push/test",
  ENTRATA: "/super-admin/entrata",
  NETWORK_SETTINGS: "/super-admin/network_settings",
  NETWORK_CREATION: "/super-admin/network_creation",
  FAILURE: "/failure",
  USERS: "/users",
  USER: "/user/:id",
  REPORTS: "/reports",
  SETTINGS: "/settings",
  NETWORK: "/settings/unit-types",
  GENERAL_SETTINGS_BASE: "/settings/general-settings/",
  GENERAL_SETTINGS: "/settings/general-settings/community-info",
  MATCH_RULES_BASE: "/settings/match-rules/",
  MATCH_RULES: "/settings/match-rules/matching-round-dates",
  PROFILE_BASE: "/settings/profile/",
  PROFILE: "/settings/profile/lifestyle-questions",
  SUPER_ADMIN: "/super-admin",
  USERS_SEARCH: "/users/search",
  USERS_INVITE: "/users/invite",
  USERS_REMOVE: "/users/remove",
  USERS_MATCH: "/users/match",
  PLACEMENT_WORKSHEET: "/users/placement-worksheet",
  DAILY_ACTIVITY_REPORT: "/reports/activity-report",
  INTEGRATIONS: "/settings/integrations",
  USER_NOTIFICATIONS: "/settings/user-notifications",
  USER_REPORT: "/reports/user-report",
  ROOMMATE_MATCHING_REPORT: "/reports/roommate-report",
  SEND_TO_ENTRATA: "/users/send-to-entrata",
};

export const getResourcesUrl = (isApt?: boolean) =>
  IS_CARDINAL_ORIGIN
    ? CARDINAL_RESOURCE_URL
    : isApt
      ? APT_RESOURCE_URL
      : DEFAULT_RESOURCE_URL;

export const getContractUrl = () =>
  IS_ACC_ORIGIN
    ? ACC_CONTACT_URL
    : IS_LANDMARK_ORIGIN
      ? LANDMARK_CONTACT_URL
      : IS_CARDINAL_ORIGIN
        ? CARDINAL_CONTACT_URL
        : DEFAULT_CONTACT_URL;

export const REPORTS_SUBNAV_LINKS = [
  { name: "User Report", url: URL.USER_REPORT },
  { name: "Roommate Report", url: URL.ROOMMATE_MATCHING_REPORT },
  // { name: "Daily Activity Report", url: URL.DAILY_ACTIVITY_REPORT },
];

export const HELP_SUBNAV_LINKS = [
  { name: "Resources", externalUrl: getResourcesUrl },
  { name: "Contact Us", externalUrl: getContractUrl },
];

export const SETTINGS_SUBNAV_LINKS = [
  { name: "Match Rules", url: URL.MATCH_RULES, baseUrl: URL.MATCH_RULES_BASE },
  { name: "Resident Profiles", url: URL.PROFILE, baseUrl: URL.PROFILE_BASE },
  { name: "Resident Notifications", url: URL.USER_NOTIFICATIONS },
  { name: "Unit Types", url: URL.NETWORK },
  {
    name: "Integrations",
    url: URL.INTEGRATIONS,
    networkTypes: ["ENTRATA", "ACC", "SFTP", "RMS", "Kinetic", "Email"],
  },
  { name: "General", url: URL.GENERAL_SETTINGS, baseUrl: URL.GENERAL_SETTINGS_BASE },
];

export const SUPER_ADMIN_SUBNAV_LINKS = [
  { name: "Tags", url: TAGS },
  { name: "Admin Access Control", url: URL.ADMIN_ACCESS_REQUEST_CONTROL },
  { name: "Notification Test", url: URL.PUSH_TEST },
  { name: "Entrata", url: URL.ENTRATA },
  { name: "Network Settings", url: URL.NETWORK_SETTINGS },
  { name: "Network Creation", url: URL.NETWORK_CREATION },
  { name: "Portfolios", url: PORTFOLIO_LIST },
  { name: "Profile Photos", url: PROFILE_PHOTO_JOBS },
];

export const READ_SUPER_ADMIN_SUBNAV_LINKS = [
  { name: "Network Creation", url: URL.NETWORK_CREATION },
];
